import { configureStore } from "@reduxjs/toolkit";
import type { TypedUseSelectorHook} from "react-redux";
import { useDispatch, useSelector } from "react-redux";
// ...
import authReducer from "./features/auth/authSlice";
import counterReducer from "./features/counter/counterSlice";
import drawerReducer from "./features/drawer/drawerSlice";
import loadingReducer from "./features/loading/loadingSlice";
import themeReducer from "./features/theme/themeSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    counter: counterReducer,
    drawer: drawerReducer,
    loading: loadingReducer,
    theme: themeReducer,
  },
});

export { store };

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch;
